import React from 'react';
import Icon from '../Icon/Icon';
import PropTypes from 'prop-types';
import './styles.css';

const Hint = (props) => {
    const { title, text, type, className, icon } = props;
    const hint = [title, text].filter(Boolean).join(': ');

    let types = 'text-gray-700 text-sm';
    switch (type) {
        case 'warning':
            types = 'text-yellow-500 text-sm';
            break;
        case 'error':
            types = 'text-red-500 text-sm';
            break;
        default:
            types = 'text-gray-700 text-sm';
    }

    return (
        <div className={className}>
            {text && text !== '' && (
                <span>
                    <label
                        title={hint}
                        aria-label={hint}
                        className="inline-flex items-center justify-center rounded-full p-1 cursor-help hover:bg-gray-100">
                        <Icon
                            name={icon ? icon : 'info-circle'}
                            className={`${types}`}
                        />
                    </label>
                </span>
            )}
        </div>
    );
};

Hint.propTypes = {
    text: PropTypes.string.isRequired,
    type: PropTypes.string,
    title: PropTypes.string,
    className: PropTypes.string,
    dataFor: PropTypes.string,
    icon: PropTypes.string,
};

export default Hint;
